import { fetchRequest } from 'src/utils/fetchRequest';

export async function logoutRequest(): Promise<boolean> {
	try {
		const response = await fetchRequest(process.env.NEXT_PUBLIC_SITECORE_LOGOUT_URL || '');

		if (!response.ok) {
			throw response.statusText;
		}

		const data = await response.json();

		if (!data.Success) {
			throw 'Logout unsuccessful';
		}

		return true;
	} catch (error) {
		console.error(error);
		return false;
	}
}
